<template>
    <base-modal
      :ref="modal.key"
      :show="open"
      maxWidth="800"
      :title="modalTitle"
      @on-confirm="saveItem"
      @on-cancel="hide()"
      :okText="$t('Save')"
      :closeText="$t('Close')"
    >
      <v-form class="mt-5">
        <v-row>
          <v-col>
            <v-text-field
              v-bind:label="$t('Title')"
              v-model="widgetTitle"
              @blur="editingWidgetTitle = false"
              @focus="editingWidgetTitle = true"
            ></v-text-field>
          </v-col>
          <v-col>
            <ColorPicker :label="$t('Color')" v-model="model.color" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ColorPicker
              :label="`${$t('Color')} (${$t('DocumentFailed')})`"
              v-model="model.errorColor"
            />
          </v-col>
          <v-col>
            <ColorPicker
              :label="`${$t('TextColor')} (${$t('DocumentFailed')})`"
              v-model="model.errorTextColor"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ColorPicker
              :label="`${$t('Color')} (${$t('DocumentPendingReview')})`"
              v-model="model.pendingColor"
            />
          </v-col>
          <v-col>
            <ColorPicker
              :label="`${$t('TextColor')} (${$t('DocumentPendingReview')})`"
              v-model="model.pendingTextColor"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ColorPicker
              :label="`${$t('Color')} (${$t('DocumentRecognized')})`"
              v-model="model.recognizedColor"
            />
          </v-col>
          <v-col>
            <ColorPicker
              :label="`${$t('TextColor')} (${$t('DocumentRecognized')})`"
              v-model="model.recognizedTextColor"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-switch
              color="primary"
              v-model="model.enableHorizontalScrolling"
              v-bind:label="$t('EnableHorizontalScrolling')"
            ></v-switch>
          </v-col>
        </v-row>
      </v-form>
    </base-modal>
  </template>

  <script>
import { validationMixin } from 'vuelidate';
import ColorPicker from '@/components/widgets/ColorPicker';
import Settings from '@/ecm/models/widget/documentTracker/DocumentTrackerSettings';

export default {
    components: {
        ColorPicker,
    },
    data() {
        return {
            fieldList: [],
            model: new Settings(),
            modal: {
                key: 'documentTrackerModal',
            },
            open: false,
            editingWidgetTitle: false,
        };
    },
    mixins: [validationMixin],
    validations: {
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        widgetTitle: {
            get() {
                if (!this.editingWidgetTitle && !this.model.title) {
                    return this.$t('WidgetAutorecognitionTrackerTitle');
                }
                return this.model.title;
            },
            set(val) {
                this.model.title = val;
            }
        },
        modalTitle() {
            return `${this.widgetTitle} - ${this.$t('Settings')}`;
        },
    },
    methods: {
        saveItem() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }
            this.$emit('on-save', this.model);
            this.hide();
        },
        edit(model) {
            this.$v.$reset();
            this.model = model;
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
  </script>
